import React from 'react';
import { Configuration, WorkspacesApi } from '@emilgroup/auth-sdk';
import { sessionConfiguration } from 'Services/sdk-session';
import { publicApiUrl } from 'App/utils';

export const useWorkspacesApi = () => {
  const [ api ] = React.useState( () => new WorkspacesApi( sessionConfiguration( Configuration ), publicApiUrl ) );
  return api;
};
